import { Bus, School, Laptop, BookOpen, GraduationCap, Clapperboard, Folder, FileText } from 'lucide-react';

const MAP = {
  bus: Bus,
  school: School,
  laptop: Laptop,
  book: BookOpen,
  graduation: GraduationCap,
  video: Clapperboard,
  folder: Folder,
  file: FileText,
};

export default function ProjectIcon({ name, className = 'w-6 h-6' }) {
  const Icon = MAP[name] || Folder;
  return <Icon className={className} />;
}
